"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_MENU = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.CONTEXT_MENU = 'CONTEXT_MENU';
